module.exports = __webpack_public_path__ + "r-v3/img/Eraser_off.7373e825.svg";